import axios from 'axios'
import authHeader from '@/services/auth/auth-header';
import Cookies from 'js-cookie';

const http = (app) => {

  const _http = axios.create();
  _http.interceptors.request.use(
    (req) => {
      req.maxContentLength = Infinity
      req.maxBodyLength = Infinity
      req.headers["Authorization"] = authHeader()
      req.headers["Params"] = Cookies.get('google_access_token')
      app.config.globalProperties.$eventBus.emit('data-loading');
      return req
    }
  )

  app.config.globalProperties.$http = _http

  return app
}

export {
  http
}
